import { createApp, h } from 'vue';
import Notifications from '@kyvg/vue3-notification';
import { ErrorHandler } from '@amarkets/atlas/esm/lib/error-handler';
import { App } from '@/app';
import { I18N_ERROR_KEYS } from '@/constants';
import { createUiServiceProvider } from './factories/create-ui-service-provider';
import { registerFeatureModules } from './global-registrations/register-feature-modules';
import { registerPlugins } from './global-registrations/register-plugins';
import { registerStoreModules } from './global-registrations/register-store-modules';
import { initGtm } from '@/plugins/vue-gtm/index.js';

export const mountApp = ({
  router,
  store,
  pinia,
  vuetify,
  i18n,
  uiNotifier,
  sentry,
  httpErrorParser,
  centrifuge,
  isWebview,
  ...rest
}) => {
  const app = createApp(App);
  const sentryInstance = sentry({ app, router });

  /*
    Для доступа к методам sentry и i18n в других местах (в рамках FSD)
    мы передаем его в глобальный объект window. Это временное решение
  */
  window.sentry = sentryInstance._sentry;
  window.i18n = i18n;
  registerPlugins({
    app,
    plugins:
      [
        vuetify,
        store,
        pinia,
        i18n,
        Notifications,
        router,
      ],
  });

  const errorHandler = new ErrorHandler({
    httpErrorParser,
    errorTracker: sentryInstance,
    uiNotifier,
    defaultErrorMsg: I18N_ERROR_KEYS.DEFAULT,
    logger: {
      error: console.error,
    },
    i18n,
  });

  registerFeatureModules(app, {
    router,
    store,
    vuetify,
    i18n,
    h,
    uiNotifier,
    httpErrorParser,
    errorHandler,
    ...rest,
  });
  registerStoreModules({
    router,
    store,
    vuetify,
    i18n,
    uiNotifier,
    sentry,
    httpErrorParser,
    errorHandler,
    ...rest,
  });

  createUiServiceProvider({
    vuetify,
    isWebview,
    uiNotifier,
    store,
    centrifuge,
    app,
  });

  const isProductionEnv = import.meta.env.VITE_ENV === 'production';

  if (isProductionEnv) {
    initGtm(app, { id: 'GTM-TPLMTK' });
  }

  app.mount('#app');
};
